"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Checked = `"data:image/svg+xml, %3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M9.73327 3.2L4.59993 8.33333L2.2666 6' stroke='white' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E"`;
exports.default = Checked;
